var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFamilyOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3523_168400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3523_168400",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.394531 1.90735e-06H32.3946V32H0.394531V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3523_168400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 0.625C17.2695 0.970188 16.9897 1.25 16.6445 1.25C16.2994 1.25 16.0195 0.970188 16.0195 0.625C16.0195 0.279813 16.2994 1.19209e-07 16.6445 1.19209e-07C16.9897 1.19209e-07 17.2695 0.279813 17.2695 0.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.881 13.7849C13.881 15.6817 12.3432 17.2195 10.4463 17.2195C8.54947 17.2195 7.01172 15.6817 7.01172 13.7849C7.01172 11.888 8.54947 10.3502 10.4463 10.3502C12.3432 10.3502 13.881 11.888 13.881 13.7849Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7677 13.7849C25.7677 15.6817 24.2299 17.2195 22.3331 17.2195C20.4361 17.2195 18.8984 15.6817 18.8984 13.7849C18.8984 11.888 20.4361 10.3502 22.3331 10.3502C24.2299 10.3502 25.7677 11.888 25.7677 13.7849Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2317 4.07973C18.4476 3.29567 17.1763 3.29567 16.3923 4.07973C15.6081 3.29567 14.337 3.29567 13.5529 4.07973C12.7688 4.8638 12.7688 6.13505 13.5529 6.91917L15.4283 8.79467L16.3923 9.75854L19.2317 6.91917C20.0158 6.13505 20.0158 4.8638 19.2317 4.07973Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51172 21.8237V21.225C4.51172 20.1187 4.95984 19.1175 5.68485 18.3925C6.40978 17.6681 7.4111 17.2194 8.51735 17.2194H12.386C13.3849 17.2194 14.2992 17.5856 15.0004 18.1906",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 18.1906C18.4819 17.5856 19.3963 17.2194 20.3956 17.2194H24.2644C25.3707 17.2194 26.3719 17.6681 27.097 18.3925C27.8219 19.1175 28.27 20.1187 28.27 21.225V21.8237",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 29.7368V25.9249C12.4805 25.1968 12.7755 24.5381 13.2529 24.0606C13.7298 23.5837 14.3892 23.2887 15.1173 23.2887H17.6642C18.3924 23.2887 19.0517 23.5837 19.5286 24.0606C20.0054 24.5381 20.3011 25.1968 20.3011 25.9249V29.7362",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1297 20.5497C19.1297 22.0622 17.9035 23.2883 16.391 23.2883C14.8785 23.2883 13.6523 22.0622 13.6523 20.5497C13.6523 19.0372 14.8785 17.8111 16.391 17.8111C17.9035 17.8111 19.1297 19.0372 19.1297 20.5497Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8317 0.625H9.62242C9.62242 4.38819 6.57179 7.43888 2.80859 7.43888V14.2059C2.80859 27.7869 16.3896 31.375 16.3896 31.375C16.3896 31.375 29.9705 27.7869 29.9705 14.2059V7.43888C26.2073 7.43888 23.1566 4.38819 23.1566 0.625H19.4567",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3523_168400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0001,
    height: 32,
    fill: "white",
    transform: "translate(0.386719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFamilyOutlinedWhite);
export default __webpack_public_path__ + "static/media/icon_family_outlined_white.f2cf7323cc609c1299c1d208694b7fb6.svg";
export { ForwardRef as ReactComponent };